// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EqX6duRjprsoYLgSf3UY {
  background: var(--grey-color-10);
  padding: 32px;
}

.jl3sLwXkM9QzehGI9Fxc {
  position: absolute;
  top: 4px;
  left: 386px;
}

.UfrREtsXeQWOlVzTf32i {
  background-color: var(--background-color);
  padding: 16px 32px;
  border-radius: 10px;
}

.ZH1rCZjs7hFsgF7cUIif {
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  padding: 32px 0px;
}

.cIAn9SMq865KyOIwr05x {
  background-color: var(--background-color);
  padding: 32px;
}

.av8vZa5Xz5hmdy5Qcxqs {
  display: flex;
  flex-direction: column;
}

.gzVL1lc9xqevaL8DXhO5 {
  display: grid;
  grid-auto-flow: column;
  padding-right: 48px;
}

.c53FbOPW6y8pduzLte7W {
  display: grid;
  grid-auto-flow: column;
  justify-content: end;
  align-items: center;
  padding-top: 4px;
}

.H3w3l2rqPqNWh_QPZCR7 {
  width: 100%;
  padding-top: 32px;
}

.DdDIHnpzn5LO0D0GONVz {
  width: 1px;
  height: 18px;
  background-color: var(--grey-gradient-end-color-10);
}

.HXEhMyaeB1aBwQZBRBJS {
  width: 14px;
  height: 14px;
  border: 1px solid;
  border-radius: 14px;
  margin: 4px 8px;
}

.jpIrSh5WvbSKSd1_Nx1t {
  width: 54px;
  height: 24px;
  margin: 0 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/CohortInsights/CohortInsights.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;AACF;;AAEA;EACE,yCAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;AACF;;AAEA;EACE,yCAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,iBAAA;AACF;;AAEA;EACE,UAAA;EACA,YAAA;EACA,mDAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AACF","sourcesContent":[".container {\n  background: var(--grey-color-10);\n  padding: 32px;\n}\n\n.skillSwitcher {\n  position: absolute;\n  top: 4px;\n  left: 386px;\n}\n\n.levelledLegendContainer {\n  background-color: var(--background-color);\n  padding: 16px 32px;\n  border-radius: 10px;\n}\n\n.metricContainer {\n  display: grid;\n  grid-auto-flow: column;\n  justify-content: space-between;\n  padding: 32px 0px;\n}\n\n.leaderDistChartDownloadableContainer {\n  background-color: var(--background-color);\n  padding: 32px;\n}\n\n.leaderDistChartContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.leaderDistChartHeaderContainer {\n  display: grid;\n  grid-auto-flow: column;\n  padding-right: 48px;\n}\n\n.leaderDistChartHeaderSub {\n  display: grid;\n  grid-auto-flow: column;\n  justify-content: end;\n  align-items: center;\n  padding-top: 4px;\n}\n\n.leaderDistChartStyle {\n  width: 100%;\n  padding-top: 32px;\n}\n\n.verticalDivider {\n  width: 1px;\n  height: 18px;\n  background-color: var(--grey-gradient-end-color-10);\n}\n\n.levelCircle {\n  width: 14px;\n  height: 14px;\n  border: 1px solid;\n  border-radius: 14px;\n  margin: 4px 8px;\n}\n\n.levelText {\n  width: 54px;\n  height: 24px;\n  margin: 0 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EqX6duRjprsoYLgSf3UY`,
	"skillSwitcher": `jl3sLwXkM9QzehGI9Fxc`,
	"levelledLegendContainer": `UfrREtsXeQWOlVzTf32i`,
	"metricContainer": `ZH1rCZjs7hFsgF7cUIif`,
	"leaderDistChartDownloadableContainer": `cIAn9SMq865KyOIwr05x`,
	"leaderDistChartContainer": `av8vZa5Xz5hmdy5Qcxqs`,
	"leaderDistChartHeaderContainer": `gzVL1lc9xqevaL8DXhO5`,
	"leaderDistChartHeaderSub": `c53FbOPW6y8pduzLte7W`,
	"leaderDistChartStyle": `H3w3l2rqPqNWh_QPZCR7`,
	"verticalDivider": `DdDIHnpzn5LO0D0GONVz`,
	"levelCircle": `HXEhMyaeB1aBwQZBRBJS`,
	"levelText": `jpIrSh5WvbSKSd1_Nx1t`
};
export default ___CSS_LOADER_EXPORT___;
